// extracted by mini-css-extract-plugin
export default {"BackToRepositorySelectionButton":"RepositoryAndIssuePicker-module__BackToRepositorySelectionButton__pOSHR9Y"};